
(function () {
  function initFaq(root) {
    if (!root || root.dataset.eocFaqReady === 'true') return;
    root.dataset.eocFaqReady = 'true';
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-eoc-faq-button]');
      if (!button || !root.contains(button)) return;
      var item = button.closest('[data-eoc-faq-item]');
      var wasOpen = item.classList.contains('is-open');
      root.querySelectorAll('[data-eoc-faq-item].is-open').forEach(function (openItem) {
        openItem.classList.remove('is-open');
        var openButton = openItem.querySelector('[data-eoc-faq-button]');
        if (openButton) openButton.setAttribute('aria-expanded', 'false');
      });
      if (!wasOpen) {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
      }
    });
  }
  function initAll(scope) {
    (scope || document).querySelectorAll('[data-eoc-faq-root]').forEach(initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
